import React, { useState, useEffect } from 'react';

import { useTheme } from 'styled-components';

import { FaFileExcel, FaMedal, FaTrophy } from 'react-icons/fa';
import { FaFilePdf } from 'react-icons/fa';
import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';
import { FaTag } from 'react-icons/fa';
import { FaThList } from 'react-icons/fa';

import api from '~/services/api';

import { exportCsv } from '~/helpers/csv';
import { exportPdf } from '~/helpers/pdf';

import {
  Scroll,
  Container,
  Header,
  Progress,
  Loading,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
} from '~/components';

import { GraphArea, LoadArea, Tags, ToogleInfo, Align } from './styles';

import Grafico from './Grafico';

import RelatorioVendaCategorias from '~/@types/relatoriovendacategorias';
import RelatorioVendaCategoriasCategoria from '~/@types/relatoriovendacategoriascategoria';
import { CountItem, ProgressTag } from '../Dashboard/styles';
import { Champion } from '../TopProdutos/styles';

const VendasPorCategoria: React.FC = () => {
  const { colors } = useTheme();

  const [inLoad, setInLoad] = useState(false);

  const [vendascategorias, setVendascategorias] = useState<
    RelatorioVendaCategorias[]
  >([]);
  const [vendasCategoriaVisibilidade, setGraficoVisibilidade] = useState(true);
  const [moduloGrafico, setModuloGrafico] = useState('hoje');

  // MODULO (VENDAS POR CATEGORIA)
  const filtrarUfsPorModulo = (
    pModuloGrafico: string,
    pGraficos: RelatorioVendaCategorias[],
  ) => {
    const categorias: RelatorioVendaCategoriasCategoria[] = [];

    let c;
    for (c in pGraficos) {
      const relatorio = pGraficos[c];
      if (relatorio.nome === pModuloGrafico) {
        let d;
        for (d in relatorio.categorias) {
          const categoria = relatorio.categorias[d];
          categorias.push(categoria);
        }
      }
    }

    return categorias;
  };

  const gerarRelatorioGraficoCSV = () => {
    let data: string[] = [];

    data.push('CATEGORIA;PEDIDOS;TICKETMEDIO;TOTAL');

    const categorias = filtrarUfsPorModulo(moduloGrafico, vendascategorias);

    let d;
    for (d in categorias) {
      const categoria = categorias[d];

      data.push(
        `${categoria.nome};${categoria.pedidos};${categoria.ticketmedio};${categoria.total}`,
      );
    }

    const csv = data.join('\n');

    exportCsv(csv, `VENDAS POR CATEGORIA - ${moduloGrafico.toUpperCase()}`);
  };

  const gerarRelatoriosGraficoPDF = () => {
    const cabecalho = ['CATEGORIA', 'PEDIDOS', 'TICKETMEDIO', 'TOTAL'];

    const data: string[][] = [];

    const categorias = filtrarUfsPorModulo(moduloGrafico, vendascategorias);

    let d;
    for (d in categorias) {
      const categoria = categorias[d];

      const linha: string[] = [];

      linha.push(`${categoria.nome}`);
      linha.push(`${categoria.pedidos}`);
      linha.push(`${categoria.ticketmedio}`);
      linha.push(`${categoria.total}`);

      data.push(linha);
    }

    exportPdf(
      cabecalho,
      data,
      `VENDAS POR CATEGORIA - ${moduloGrafico.toUpperCase()}`,
    );
  };

  const exibicaoTotalPedidos = (pTotalPedidos: number) => {
    if (!pTotalPedidos) return 'Nenhum pedido';
    if (pTotalPedidos === 1) {
      return 'Um pedido';
    }
    return `${pTotalPedidos} pedidos`;
  };

  useEffect(() => {
    const fetchVendasPorCategoria = async () => {
      try {
        setInLoad(true);
        setVendascategorias([]);

        const ano = new Date().getFullYear();
        const modulo = 'vendas_top_categorias';

        const response = await api.get(
          `relatorios?ano=${ano}&modulo=${modulo}`,
        );

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          setVendascategorias(data);
        }

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };
    fetchVendasPorCategoria();
  }, []);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Top Categorias"
            subtitle="Confira as métricas de vendas distribuídas pelas categorias mais vendidas"
            icon={
              <>
                <FaThList size={28} color={colors.IC1} />
              </>
            }
          />

          {inLoad ? (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          ) : null}

          {vendascategorias.length ? (
            <GraphArea>
              <header>
                <i>
                  <FaThList size={24} color={colors.IC1} />
                </i>
                <p>
                  <h1>Top Categorias</h1>
                  <h2>
                    Confira as métricas de vendas distribuídas pelas categorias
                    mais vendidas
                  </h2>
                </p>

                <div>
                  <button
                    className="excel"
                    onClick={gerarRelatorioGraficoCSV}
                    title="Exportar para Excel"
                  >
                    <FaFileExcel size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>EXCEL</h2>
                    </div>
                  </button>
                  <button
                    className="pdf"
                    onClick={gerarRelatoriosGraficoPDF}
                    title="Exportar para PDF"
                  >
                    <FaFilePdf size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>PDF</h2>
                    </div>
                  </button>
                </div>
              </header>

              <Tags>
                <div>
                  <button
                    className={moduloGrafico === 'hoje' ? 'active' : ''}
                    onClick={() => setModuloGrafico('hoje')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Hoje</span>
                  </button>
                  <button
                    className={
                      moduloGrafico === 'ultimos-7-dias' ? 'active' : ''
                    }
                    onClick={() => setModuloGrafico('ultimos-7-dias')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Últimos 7 Dias</span>
                  </button>
                  <button
                    className={moduloGrafico === 'mes-atual' ? 'active' : ''}
                    onClick={() => setModuloGrafico('mes-atual')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Mês Atual</span>
                  </button>
                  <button
                    className={moduloGrafico === 'mes-passado' ? 'active' : ''}
                    onClick={() => setModuloGrafico('mes-passado')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Mês Passado</span>
                  </button>
                  <button
                    className={moduloGrafico === 'ano-atual' ? 'active' : ''}
                    onClick={() => setModuloGrafico('ano-atual')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Ano Atual</span>
                  </button>
                  <button
                    className={moduloGrafico === 'ano-passado' ? 'active' : ''}
                    onClick={() => setModuloGrafico('ano-passado')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Ano Passado</span>
                  </button>
                </div>
              </Tags>

              <main>
                <div>
                  <Grafico
                    categorias={filtrarUfsPorModulo(
                      moduloGrafico,
                      vendascategorias,
                    )}
                  />
                </div>
              </main>

              <footer>
                {vendasCategoriaVisibilidade ? (
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="" width={40} />
                      <GridHeadItem title="Categoria" />
                      <GridHeadItem title="Pedidos" width={150} />
                      <GridHeadItem title="Total" width={150} />
                      <GridHeadItem title="Ticket Médio" width={150} />
                    </GridLine>

                    {filtrarUfsPorModulo(moduloGrafico, vendascategorias).map(
                      categoria => (
                        <GridLine key={categoria.nome}>
                          <GridItem width={40}>
                            <Align>
                              <CountItem>{categoria.posicao}</CountItem>
                              {categoria._posicao <= 3 ? (
                                <Champion>
                                  {categoria._posicao === 1 ? (
                                    <FaTrophy size={18} color={colors.IC1} />
                                  ) : (
                                    <FaMedal size={18} color={colors.IC1} />
                                  )}
                                </Champion>
                              ) : null}
                            </Align>
                          </GridItem>
                          <GridItem>
                            <Align>
                              <strong>{categoria.nome.toUpperCase()}</strong>
                            </Align>
                          </GridItem>
                          <GridItem width={150}>
                            <Align>
                              <div>
                                {exibicaoTotalPedidos(categoria.pedidos)}
                              </div>
                              <ProgressTag>
                                {categoria.pedidos_porcentagem}%
                              </ProgressTag>
                            </Align>
                          </GridItem>
                          <GridItem width={150}>
                            <Align>
                              <div>
                                {categoria.total.toLocaleString('pt-br', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })}
                              </div>
                              <ProgressTag>
                                {categoria.faturamento_porcentagem}%
                              </ProgressTag>
                            </Align>
                          </GridItem>
                          <GridItem width={150}>
                            <Align>
                              {categoria.ticketmedio.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </Align>
                          </GridItem>
                        </GridLine>
                      ),
                    )}
                  </Grid>
                ) : null}
                <ToogleInfo
                  onClick={() =>
                    setGraficoVisibilidade(!vendasCategoriaVisibilidade)
                  }
                >
                  {vendasCategoriaVisibilidade ? (
                    <IoMdArrowDropup size={32} color={colors.IC1} />
                  ) : (
                    <IoMdArrowDropdown size={32} color={colors.IC1} />
                  )}
                </ToogleInfo>
              </footer>
            </GraphArea>
          ) : null}
        </Container>
      </Scroll>
    </>
  );
};

export default VendasPorCategoria;
